import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'nprogress/nprogress.css'

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import vuetify from './plugins/vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import axios from 'axios'
import { getUrlParameter } from './Constants.js'
import api from './services/api'

const requireComponent = require.context(
  './components',
  false,
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.config.productionTip = false
Vue.prototype.$http = api

new Vue({
  router,
  store,
  vuetify,
  created() {
    // //check if a token is part of querystring
    // const token = getUrlParameter('token')
    // if (
    //   token != null &&
    //   token !== undefined &&
    //   token !== 'undefined' &&
    //   token !== ''
    // ) {
    //   this.$store.commit('user/SET_TOKEN', token)
    // }

    const userString = localStorage.getItem('user')
    if (
      userString != null &&
      userString !== undefined &&
      userString !== 'undefined'
    ) {
      const userData = JSON.parse(userString)
      this.$store.commit('user/SET_USER_DATA', userData)
    }
  },
  render: h => h(App)
}).$mount('#app')
